import { DuplicationSubMenu } from '../DuplicationSubMenu'
import type {
  MutableActionDefs,
  MutableActionArgs,
  MutableAction,
  ExcludeActionType,
} from '../types'

const MutableActionFactory = {
  mutable_more: ({ items = [] }) => ({
    type: 'submenu',
    label: 'More...',
    actionType: 'mutable_more',
    items,
  }),
  edit: {
    type: 'action',
    label: 'Edit Content',
    actionType: 'edit',
  },
  duplicate: ({ disabled }) => ({
    type: 'action',
    label: 'Duplicate Content',
    actionType: 'duplicate',
    component: DuplicationSubMenu,
    disabled,
  }),
  move: {
    type: 'action',
    label: 'Move Content',
    actionType: 'move',
  },
  localize: {
    type: 'action',
    label: 'Localize Content',
    actionType: 'localize',
  },
  generate_content: ({ disabled }) => ({
    type: 'action',
    label: 'Generate Content 🤖',
    actionType: 'generate_content',
    disabled,
  }),
  generate_transformation: ({ disabled }) => ({
    type: 'action',
    label: 'Transform Content 🤖',
    actionType: 'generate_transformation',
    disabled,
  }),
  create_retweet: ({ disabled }) => ({
    type: 'action',
    label: 'Create Repost',
    actionType: 'create_retweet',
    disabled,
  }),
} as const satisfies MutableActionDefs

export const getMutableActions = ({
  contentGenerationEnabled,
  contentTransformationEnabled,
  duplicationEnabled,
  isPresenting,
  queueView,
  retweetEnabled,
  serviceName,
  showAIActions,
  userCanEditContent,
}: MutableActionArgs): MutableAction[] => {
  if (!userCanEditContent) return []

  const mutableActions: ExcludeActionType<MutableAction, 'mutable_more'>[] = []

  if (!isPresenting) {
    mutableActions.push(MutableActionFactory.edit)

    if (!queueView) {
      mutableActions.push(
        MutableActionFactory.duplicate({ disabled: !duplicationEnabled }),
        MutableActionFactory.move
      )

      if (showAIActions) {
        mutableActions.push(
          MutableActionFactory.generate_content({
            disabled: !contentGenerationEnabled,
          }),
          MutableActionFactory.generate_transformation({
            disabled: !duplicationEnabled || !contentTransformationEnabled,
          })
        )
      }
    }
  }

  mutableActions.push(MutableActionFactory.localize)

  if (serviceName === 'twitter' && !isPresenting) {
    mutableActions.push(
      MutableActionFactory.create_retweet({ disabled: !retweetEnabled })
    )
  }

  // If more than 4 actions are available, show the first 3,
  // then push the remainder into a 'More' menu
  if (mutableActions.length > 4) {
    return [
      ...mutableActions.slice(0, 3),
      MutableActionFactory.mutable_more({ items: mutableActions.slice(3) }),
    ]
  }

  return mutableActions
}
